module.exports = __webpack_public_path__ + "static/media/sz.9ec8da3e.svg";